
type Abbreviation = string;  // this can be explicit to scope Abbreviations to only known apps
type CompositeId = string;  // e.g: `${typeof Abbreviation}:${applicationUserId}`

class UserApplication {
	public applicationId: number = -1;  // Application
	public applicationUserId: number = -1;  // Client (User may belong to multiple Clients)
	public userId: number = -1;  // Active User
	public name: string = '';
	public abbreviation: Abbreviation = '';
	public clientName: string = '';
	public description: string = '';
	public backdoorLoginUrl: string = '';
	public isActive: boolean = false;
	public maintenanceMode: boolean = false;
	public isTestOnly: boolean = false;
	public multiclient: boolean = false;
	public clientId: number;
	public hasChildApplicationLoginPermission: boolean = true;
	public customClaims: string;
    public excludeToken = false;
	
	get id(): CompositeId { return `${this.abbreviation}:${this.applicationUserId}`; }  // e.g: 'HuR:444752'
	get title() { return this.multiclient && `${this.name} - ${this.clientName}` || this.name; }  // e.g: 'Huron Rounding - ACME Health'

	constructor(options: any = {}) {
		var options = options || { };  // can be null; use empty object ({}) to enforce optionless instance.
		var booleans = { true: true, false: false, null: false, undefined: false };

		this.applicationId = +options.applicationId;
		this.applicationUserId = +options.applicationUserId;
		this.userId = +options.userId;
		this.name = options.name || this.name;
		this.abbreviation = options.abbreviation || this.abbreviation;
		this.clientName = options.clientName || this.clientName;
		this.description = options.description || this.description;
		this.backdoorLoginUrl = options.backdoorLoginUrl || this.backdoorLoginUrl;
		this.isActive = booleans[ options.isActive ];
		this.maintenanceMode = booleans[ options.maintenanceMode ];
		this.isTestOnly =  booleans[ options.isTestOnly ];
		this.multiclient = booleans[ options.multiclient ];
		this.clientId = +options.clientId || this.clientId;
		this.hasChildApplicationLoginPermission = options.hasChildApplicationLoginPermission || this.hasChildApplicationLoginPermission;
		this.customClaims = options.customClaims;
        this.excludeToken = booleans[ options.excludeToken ];
		return this;
  }
}

export { UserApplication, Abbreviation, CompositeId };
